import {useEffect, useState} from 'react';
import {useTelegramTheme} from '../../../shared/utils/telegram';
import {api} from '../../../shared/services/api';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash, faSpinner} from "@fortawesome/free-solid-svg-icons";

function ActiveSessions() {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [killingSession, setKillingSession] = useState(null);

    const themeParams = useTelegramTheme();

    // Map new theme params to old naming convention for compatibility
    const theme = {
        text_color: themeParams.textColor,
        hint_color: themeParams.hintColor,
        link_color: themeParams.linkColor,
        section_bg_color: themeParams.sectionBackgroundColor,
        section_separator_color: themeParams.sectionSeparatorColor,
        bg_color: themeParams.backgroundColor,
    };

    useEffect(() => {
        const fetchSessions = async () => {
            try {
                const response = await api.get('/api/sessions/active');
                setSessions(response.sessions || []);
                setLoading(false);
            } catch (error) {
                console.error('Failed to fetch sessions:', error);
                setLoading(false);
            }
        };

        fetchSessions();
        const interval = setInterval(fetchSessions, 10000); // Update every 10 seconds

        return () => clearInterval(interval);
    }, []);

    const handleKillSession = async (session) => {
        if (!window.confirm(`Вы уверены, что хотите завершить сессию ${session.username}@${session.tty}?`)) {
            return;
        }

        setKillingSession(session.id);
        try {
            await api.delete('/api/sessions/kill', {
                username: session.username,
                tty: session.tty
            });

            // Refresh sessions list
            const response = await api.get('/api/sessions/active');
            setSessions(response.sessions || []);
        } catch (error) {
            console.error('Failed to kill session:', error);
            alert('Ошибка при завершении сессии: ' + error.message);
        } finally {
            setKillingSession(null);
        }
    };

    if (loading) {
        return (
            <div className="p-4 text-theme-text-color">
                Загрузка сессий...
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div
                className="rounded-lg border p-4 bg-theme-section-bg-color border-theme-section-separator-color"
            >
                <div className="space-y-3">
                    {sessions.map((session) => (
                        <div key={session.id} className="flex justify-between items-center">
                            <div className="flex-1">
                                <p className="text-sm font-medium text-theme-text-color">
                                    {session.username}@{session.tty}
                                </p>
                                <p className="text-sm mt-1 text-theme-hint-color">
                                    IP: {session.ip}
                                </p>
                                {session.location && (
                                    <p className="text-sm text-theme-link-color">
                                        {session.location.city}, {session.location.country}
                                    </p>
                                )}
                            </div>
                            <button
                                onClick={() => handleKillSession(session)}
                                disabled={killingSession === session.id}
                                className="px-4 py-2 rounded-lg bg-theme-destructive-text-color text-white hover:opacity-80 disabled:opacity-50 transition-opacity"
                            >
                                {killingSession === session.id ? <FontAwesomeIcon icon={faSpinner} spin /> : <FontAwesomeIcon icon={faTrash} />}
                            </button>
                        </div>
                    ))}
                    {sessions.length === 0 && (
                        <p className="text-center py-4 text-theme-hint-color">
                            Нет активных сессий
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ActiveSessions;
